// Sugar Alarm — cycle 435: the Settings hero card's sparkline geometry,
// moved out of the component so the only `.sgv` a presentation module
// reads off a raw `Reading` is inside a chart (the AST guard,
// `__tests__/currentGlucoseGuard.test.ts`). History maths, never the
// number: the card paints its value from the selector alone.

import type { Reading } from "./types";

/** Minimal inline sparkline path from a chronological readings buffer.
 *  `<2` readings → null (the card renders without the sparkline — no
 *  error state). Byte-for-byte the cycle-161 geometry. */
export function sparkGeometry(
  readings: readonly Reading[],
): { d: string; cx: number; cy: number } | null {
  if (readings.length < 2) return null;
  const vals = readings.map((r) => r.sgv);
  const min = Math.min(...vals);
  const max = Math.max(...vals);
  const span = Math.max(1, max - min);
  const W = 120;
  const H = 44;
  const PAD = 5;
  const pts = vals.map((v, i) => {
    const x = PAD + (i / (vals.length - 1)) * (W - PAD * 2);
    const y = PAD + (1 - (v - min) / span) * (H - PAD * 2);
    return [x, y] as const;
  });
  const d = pts
    .map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)} ${y.toFixed(1)}`)
    .join(" ");
  const last = pts[pts.length - 1]!;
  return { d, cx: last[0], cy: last[1] };
}
